/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React, { useEffect, useState } from "react";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { CardsSimpleImage } from "cms/components/cards-simple/image";
import { isStringNotEmpty } from "cms/utils/empty-exists";
import { Logger } from "cms/utils/logger";

function CardsSimpleItem (props) {

    const { item } = props;
    const {
        heading = "",
        image: image_guid,
    } = item || {};

    const { token } = useAuth();
    const [image, setImage] = useState();

    useEffect(() => {
        const fetchData = async () => {
            Logger.debug(`load image ${image_guid}`);
            if (!image) {
                if (image_guid) {
                    const img = await SimpliCitySDK.images.findOne(token, image_guid);
                    setImage(img);
                }
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={"cards-simple-item"}>

            {image &&
                <CardsSimpleImage image={image} />
            }

            <div className='cards-simple-item-content'>

                {isStringNotEmpty(heading) &&
                    <p>{heading}</p>
                }

            </div>
        </div>
    );
}
export default CardsSimpleItem;
